import React from 'react'
import { graphql } from 'gatsby'
import PageLayout from '../layouts/PageLayout'
import Section from 'components/Section/Section'
import Seo from 'components/Seo'
import SectionImage from 'components/Section/SectionImage'
import { getImage, getSrc } from 'gatsby-plugin-image'
const TOSPage = ({
  data: {
    markdownRemark: {
      frontmatter: { meta, sections = [] },
    },
  },
  location: { pathname },
}) => {
  const imagePath = getSrc(meta.ogImage)
  const sectionsMap = sections.map(
    ({ content, background, ctaButton }, index) => {
      const backgroundImage = getImage(background)
      const contentImage = getImage(content.contentImage)

      return (
        <Section
          key={background.backgroundColor}
          index={index}
          fullHeight
          id={`page-section-${index}`}
          as={index === 0 ? 'header' : 'section'}
          colorTheme={background.backgroundColor}
          backgroundImage={backgroundImage}
          colorOverlay={background.colorOverlay}
          content={content}
          ctaButton={ctaButton}
          isLastSection={index === sections.length - 1}
          pathname={pathname}
          image={
            <SectionImage
              image={contentImage}
              imagePosX={content.imagePosX}
              imagePosY={content.imagePosY}
            />
          }
        />
      )
    }
  )

  return (
    <PageLayout pathname={pathname}>
      <Seo
        title={meta.title}
        description={meta.metaDescription}
        ogImage={imagePath}
        meta={meta}
        pathname={pathname}
      />
      {sectionsMap}
    </PageLayout>
  )
}

export default TOSPage

export const query = graphql`
  query TOSPageQuery {
    markdownRemark(frontmatter: { title: { eq: "terms-of-service" } }) {
      id
      frontmatter {
        meta {
          title
          metaDescription
          ogImage {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
        sections {
          content {
            body
            posX
            posY
          }
          background {
            backgroundColor
            backgroundImage {
              childImageSharp {
                gatsbyImageData
              }
            }
            colorOverlay
          }
          ctaButton {
            buttonText
            buttonURL
            scrollNext
            buttonAction
          }
        }
      }
    }
  }
`
